<script lang="ts">
  import Toasts from './components/ui/Toasts.svelte'
  import { t } from './lib/i18n/index.svelte.js'
  import { router } from './lib/router.svelte.js'
  import Home from './routes/Home.svelte'
  import ListPage from './routes/ListPage.svelte'
  import NotFound from './routes/NotFound.svelte'
  import Button from './components/ui/Button.svelte'
</script>

<svelte:boundary>
  {#if router.route.name === 'home'}
    <Home />
  {:else if router.route.name === 'list'}
    {#key router.route.token}
      <ListPage token={router.route.token} />
    {/key}
  {:else}
    <NotFound />
  {/if}

  {#snippet failed(_error, reset)}
    <main class="page error">
      <h1>{t('error_title')}</h1>
      <Button variant="primary" onclick={reset}>{t('error_retry')}</Button>
    </main>
  {/snippet}
</svelte:boundary>

<Toasts />

<style>
  .error {
    padding-top: var(--space-6);
    text-align: center;
  }
  h1 {
    margin-bottom: var(--space-4);
    font-size: 22px;
  }
</style>
